export default __webpack_public_path__ + "static/media/rockets.58ddb761.svg";